import React from 'react';
import BrandLogo from "./images/brand.png"

export default class Footer extends React.Component {
    render() {
        return (
            <footer>
                <div className="row-fluid" id="footerContent">
                    <div className="col">
                        <img src={BrandLogo} className="img-fluid" style={{ height: "32px" }}></img><h3>SkillEd</h3>
                        <small className="muli">© Copyright 2020, SkillEd</small><br></br>
                    </div>
                    <div className="col">
                        <br></br>
                        <ul style={{ color: "white" }}>
                            <i className="fab fa-linkedin socialIcon"></i>
                            <i className="fab fa-twitter socialIcon"></i>
                            <i className="fab fa-youtube socialIcon"></i>
                            <i className="fab fa-facebook socialIcon"></i>
                            <i className="fab fa-instagram socialIcon"></i>
                        </ul>
                    </div>
                    <div className="col"></div>
                </div>
            </footer>
        );
    }
}